<template>
  <div class="text-block__content">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.text-block__content {
  p {
    font-style: normal;
    font-weight: normal;
    margin-bottom: 25px;
    font-size: 16px;
    line-height: 180%;
    color: $mainFontColor;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
      margin-bottom: 25px;
    }
  }

  h1 {
    font-weight: 500;
    font-size: 28px;
    line-height: 110.1%;
    color: $mainFontColor;
    margin-bottom: 25px;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
      margin-bottom: 30px;
      font-size: 22px;
    }
  }

  h2 {
    font-style: normal;
    margin-bottom: 20px;
    font-weight: 500;
    font-size: 24px;
    line-height: 110.1%;
    color: $mainFontColor;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
    }
  }

  h3 {
    font-size: 20px;
    font-weight: bold;
    line-height: 110%;
    color: $mainFontColor;
    margin-bottom: 25px;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
    }
  }

  h4 {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 100%;
    color: $mainFontColor;
    margin-bottom: 25px;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
    }
  }

  & > h2,
  & > h3,
  & > h4 {
    &:not(:first-child) {
      margin-top: 20px;
    }
  }

  /*
		blockquote {
			p {
				display: inline;
				background-color: #E4151C;
				color: #FFFFFF;
				font-style: italic;
				font-weight: 800;
				line-height: 200%;
				padding: 3px 0;
				box-shadow: 5px 0px 0px #E4151C, -5px 0px 0px #E4151C;
				box-decoration-break: clone;
				position: relative;
				margin: 14px 0px 5px 20px;
				
				&:before {
					content: url("data:image/svg+xml;charset=utf8,%3Csvg width='16' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.91299 0.404541C4.07775 0.603768 0.00224 1.05643 0 6.60911V13.5954H6.32672V6.12058H4.22595C4.09287 4.12467 5.7364 3.6093 7.52365 3.21369L6.91299 0.404541ZM15.3893 0.404541C12.5541 0.603768 8.47856 1.05645 8.47633 6.60911V13.5954H14.8031V6.12058H12.7023C12.5692 4.12467 14.2127 3.6093 16 3.21369L15.3893 0.404541Z' fill='%23E4151C'/%3E%3C/svg%3E");
					height: 16px;
					width: 13px;
					position: absolute;
					left: -20px;
					top: -20px;
				}
			}
			
			h2, h3, h4 {
				font-size: 14px;
				font-weight: 800;
				line-height: 150%;
				margin: 0px 0px 0px 20px;
			}
		}
*/

  a {
    font-size: 16px;
    font-weight: 400;
    color: $activeColor;
    border-bottom: 1px dotted $activeColor;
    transition: all 500ms;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
    }

    &:hover {
      color: $mainFontColor;
      border-bottom: 1px dotted $mainFontColor;
    }
  }

  ol {
    counter-reset: section;
    list-style: none;
    margin-bottom: 20px;
    padding-left: 0;

    & > li {
      font-size: 16px;
      font-weight: 400;
      line-height: 180%;
      position: relative;
      padding-left: 25px;
      color: $mainFontColor;
      margin-bottom: 20px;
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
      }

      &:before {
        counter-increment: section;
        content: counter(section) ".";
        display: inline-block;
        position: absolute;
        left: 0;
        top: -8px;
        font-weight: 800;
        text-transform: uppercase;
        font-size: 16px;
        line-height: 222%;
        color: $activeColor;
      }
    }
  }

  ul {
    margin-bottom: 20px;

    & > li {
      font-size: 16px;
      font-weight: 400;
      line-height: 180%;
      color: $mainFontColor;
      position: relative;
      padding-left: 20px;
      padding-bottom: 15px;
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
      }

      &:before {
        content: "";
        height: 7px;
        width: 7px;
        background: $activeColor;
        border-radius: 50%;
        position: absolute;
        left: 0px;
        top: 10px;
      }
    }
  }
  hr {
    background: $darkColor;
    margin-bottom: 35px;
  }
}
</style>
